import { useEffect, useState } from 'react';
import styles from './delete.module.scss';
import { DeleteSellersProps } from '../../../../interfaces/components';
import { useToast } from '../../../../helpers/hooks';
import ButtonShared from '../../../../components/Button/Button';
import Modal from '../../../../components/Modal/Modal';
import { capitalize } from '../../../../helpers/app';

const Sidebar = ({
    user,
    open,
    setOpen,
    sellerSelected,
    loading,
    getSellers,
    sellers,
    deleteSeller,
    cleanDeleteSeller
}: DeleteSellersProps) => {
    const toast = useToast();

    useEffect(() => {
        if(sellers?.delete?.fetching === "failure"){
            toast("Ha ocurrido un error al eliminar el vendedor");
            cleanDeleteSeller();
        }
        if(sellers?.delete?.fetching === "success"){
            toast(`Vendedor ${capitalize(sellerSelected?.name)} ${capitalize(sellerSelected?.last_name)} eliminado correctamente`);
            setOpen(false)
            
            if(user?.profile?.code !== "admin-brand") {
                getSellers(user?.dealership, "dealership", "sellers");
            }
            cleanDeleteSeller();
        }
    }, [sellers?.delete?.fetching]);

    return (
        <Modal open={open} variant="white" className={styles.modalDeleteSeller}>
            <p>
                <span className={styles.message}>Estás a punto de eliminar el siguiente vendedor</span>
                <span className={styles.name}>{`${capitalize(sellerSelected?.name)} ${capitalize(sellerSelected?.last_name)}`}</span>
            </p>
            <div className={styles.buttons}>
                <ButtonShared 
                    onPress={() => setOpen(false)}
                    title="Regresar" 
                    tertiary
                    size="small"
                />
                <ButtonShared 
                    onPress={() => deleteSeller(sellerSelected?._id)}
                    title="Eliminar" 
                    primary
                    size="small"
                    loading={loading}
                />
            </div>
        </Modal>
    )
};
export default Sidebar;